import React, { useState } from "react";
import { MdClose } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { ownerSelector } from "../../store/store";
import { ICON } from "../assets";
import { setCurrentWorkSpace } from "../../store/slices/ownerSlice";
import { toast } from "react-toastify";
import { Button } from "../ui";

type Props = {
  onClose: () => void;
};

const WorkSpaceSelectionModal = (props: Props) => {
  const { owner, currentWorkspace } = useSelector(ownerSelector);
  const [selectedWorkspace, setSelectedWorkspace] = useState(currentWorkspace);
  const dispatch = useDispatch();

  const handleWorkspace = async () => {
    dispatch(setCurrentWorkSpace(selectedWorkspace));
    props.onClose();
    toast.success("Workspace switched successfully");
  };
  return (
    <div className="modal-overlay fixed inset-0 z-[10000] bg-black/40 backdrop-blur-sm">
      <div className="fixed inset-0 z-[10001] flex items-center justify-center p-4">
        <div className="modal-container flex w-full max-w-[760px] flex-col gap-4 rounded-[12px] border border-light-grey bg-white p-6 shadow-lg">
          <div className="flex w-full items-center justify-between">
            <h1 className="text-[30px] font-semibold text-dark-black">Switch Workspace</h1>
            <button type="button" onClick={props.onClose} aria-label="Close">
              <MdClose className="cursor-pointer text-2xl text-dark-grey transition-colors hover:text-dark-black" />
            </button>
          </div>

          <div className="noScroll flex max-h-[50vh] flex-col gap-3 overflow-y-auto">
            {owner?.workspaces.map((workspace: any) => (
              <div
                onClick={() => setSelectedWorkspace(workspace)}
                key={workspace._id}
                className={`${
                  selectedWorkspace?._id === workspace._id
                    ? "border-brand-blue bg-primary"
                    : "border-light-grey bg-background-grey"
                } flex w-full cursor-pointer items-center justify-start gap-4 rounded-[8px] border px-4 py-4 transition-colors`}
              >
                <span className="rounded-full bg-white p-2">
                  <img src={ICON} alt="" className="w-8 h-8 rounded-full" />
                </span>
                <p className="text-md font-medium text-dark-black">{workspace.name}</p>
                <span className="rounded-[6px] bg-mainColor px-2 py-1 text-xs text-white">
                  {workspace.type}
                </span>
                <p className="text-md text-dark-black">
                  {workspace.members.length}{" "}
                  {workspace.members.length > 1 ? "Members" : "Member"}
                </p>
              </div>
            ))}
          </div>

          <Button
            onClick={() => {
              handleWorkspace();
            }}
            variant="primary"
            size="md"
            className="ml-auto"
          >
            Switch Workspace
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WorkSpaceSelectionModal;
